import React from "react";
import { withRouter, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { authenticatedSelector, securityIsFetchingSelector} from "../security/securitySelectors";
import { ImportLoading } from "../common";

const AuthenticatedRouteComponent = ({
  authenticated,
  isLoading,
  component: Component,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (isLoading && !authenticated) {
          return <ImportLoading isLoading={true}/>
        } else if (!isLoading && authenticated) {
          return <Component {...props} />
        } else {
          return <Redirect to="/auth/login" />
        }
      }}
    />
  )
}

const mapStateToProps = state => ({
  authenticated: authenticatedSelector(state),
  isLoading: securityIsFetchingSelector(state)
});

const AuthenticatedRoute = withRouter(connect(mapStateToProps)(AuthenticatedRouteComponent));
export { AuthenticatedRoute };



// WEBPACK FOOTER //
// ./src/common/AuthenticatedRoute.js